import { defaultState } from './state'

export default {
    reset: (state) => {
        Object.assign(state, defaultState())
    },
    set: (state, payload = {}) => {
        Object.assign(state, payload)
    },
    setLogs: (state, logs = []) => {
        state.logs = Array.isArray(logs) ? logs : []
    },
    clearLogs: (state) => {
        state.logs = []
    }
}
